<template>
  <div class="core">
    <div class="layui-layer-content">
      <div class="layui-layer-wrap">
        <div class="form-collapse">
          <div class="info">
            <layui-form ref="allForm" :showForm="true" :rule="form_rule" :after-save="handleAfterSave">
              <div class="layui-form">
                <pub-collapse :title="formData.WORK_ORDER_CATEGORY === '1' ? '服务请求运维单信息' : '服务请求工程单信息'">
                  <template #content>
                    <layui-collapse>
                      <workOrder ref='workOrder' :editRow="formData"></workOrder>
                      <returnVisit ref='returnVisit' :editRow="formData" :enabled="false"></returnVisit>
                    </layui-collapse>
                  </template>
                </pub-collapse>

                <pub-collapse :title="formData.WORK_ORDER_CATEGORY === '1' ? '现场服务运维单信息' : '现场服务工程单信息'">
                  <template #content>
                    <layui-collapse>
                      <serviceOrder ref='serviceOrder' :editRow="formData"></serviceOrder>
                      <signinout ref='signinout' :editRow="formData"></signinout>
                      <selfCheck ref='selfCheck' :editRow="formData"></selfCheck>
                      <acceptance ref='acceptance' :editRow="formData" :enabled="orderType == 'ys'"></acceptance>
                      <backorder ref='backorder' :editRow="formData"></backorder>
                      <appraise ref='appraise' :editRow="formData"></appraise>
                    </layui-collapse>
                  </template>
                </pub-collapse>
              </div>
              <div class="layui-form-btn">
                <div class="layui-footer">
                  <button class="layui-btn refresh" title="关闭" @click="close()">关 闭</button>
                  <button class="layui-btn" title="保存" @click="save()" v-if="orderType == 'ys'">保 存</button>
                </div>
              </div>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import workOrder from '../detailForm/workOrderForm'
import returnVisit from '../detailForm/returnVisitForm'
import serviceOrder from '../detailForm/serviceOrderForm'
import signinout from '../detailForm/signInOutForm'
import selfCheck from '../detailForm/selfCheckForm'
import acceptance from '../detailForm/acceptanceForm'
import backorder from '../detailForm/backOrderForm'
import appraise from '../detailForm/appraiseForm'

/**
 * 现场服务单-查看
 */
export default {
  provide () {
    return{
      source: "siteManage"
    }
  },
  components: {
    workOrder,
    returnVisit,
    serviceOrder,
    backorder,
    signinout,
    selfCheck,
    acceptance,
    appraise
  },
  props: {
  },
  data () {
    return {
      form_rule: {
        MANAGER_ID: {
          required: { message: '项目经理不能为空' }
        },
      },
      formData: {},
      orderType: '',
      scrollTop: 0
    }
  },
  activated(){
    if(this.scrollTop) {
      $(".core").animate({scrollTop: this.scrollTop}, 0)
    }
    //如果二级菜单不展示，底部样式修改
    if(!$('.layui-side-scroll').is(":visible")){
        $(".layui-footer").css("left","0");
    } else {
        $(".layui-footer").removeAttr("style");
    }
  },
  mounted () {
    if(this.tabParam) {
      this.formData = this.tabParam.formData;
      this.orderType = this.tabParam.orderType;
      this.tableObj = this.tabParam.tableObj;
    }
    this.$nextTick(()=> {
      if(this.orderType === 'ys'){
        this.formData.ACCEPTANCE_RESULT = '1';
        var anchor = this.$refs.acceptance.$el.offsetTop;
        $(".core").animate({
          scrollTop: anchor
        },500);
      }
    })
    var that = this;
    $(".core").scroll(function(event){
      that.scrollTop = $(".core").scrollTop();
    })
  },
  methods: {
      /**
     * 关闭
     */
    close() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu);
      if(this.tabParam.from == 'acceptForm'){
        this.baseComponent.currentComponent = this.tabParam.sourceMenu;
      } else if(this.tabParam.from == 'operLog'){
        this.baseComponent.loadComponentByName(this.tabParam.from);
      } else {
        this.baseComponent.loadComponentByName('siteManage');
      }
    },
    /**
     * 保存
     */
    save() {
      this.$refs.allForm.editRow = $.extend(true, {}, this.$refs.acceptance.editRow);
      if(this.$refs.allForm.editRow.ACCEPTANCE_RESULT == '1'){//通过
        this.$refs.allForm.editRow.SERVICE_STATE = '6';//6.待签退
      } else if(this.$refs.allForm.editRow.ACCEPTANCE_RESULT == '0'){//不通过
        this.$refs.allForm.editRow.SERVICE_STATE = '10';//10.验收不通过
      }

      if (this.$refs.acceptance.editRow.WORK_ORDER_METHOD === '3') {
        this.$refs.allForm.requestUniqueId = "thirdPartyServiceOrderAccept";
      } else {
        this.$refs.allForm.requestUniqueId = "serviceOrderAccept";
      }

      this.$refs.allForm.callableSave("YW_SERVICE_ORDER");
    },
    handleAfterSave() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu)
      this.baseComponent.loadComponentByName('siteManage')
      if(this.tabParam.from == 'acceptForm'){
        this.$bus.$emit('acceptForm');
      } else {
        if (this.tableObj) {
          this.tableObj.pageInfo.pageIndex = 1
          this.tableObj.load()
        }
      }
    },
  }
}
</script>
<style scoped>
  /* .core .layui-form {
    padding: 10px 20px;
  } */
</style>



// WEBPACK FOOTER //
// src/components/workOrder/siteManage/siteForm.vue